export const appConstants = {
  mainAppBarHeight: 64,
  userDrawerWidth: 550,
  drawerWidth: 240,
  dateFormat: "YYYY-MM-DD",
  hourTimeFormat: "HH:mm",
}
